import api from "./interceptorServices"
import { API_URL_LINK } from "./ApiURL"

const API_URL = API_URL_LINK
// const API_URL = "http://localhost:8000/api/"

const GetBetsPerAgent = async (body) => {
  try {
    const { data } = await api.post(`${API_URL}bet/betperagent`, body)
    // console.log(data)
    return data
  } catch (error) {
    console.log(error)
  }
}

const GetBets = async (body) => {
  try {
    const { data } = await api.post(`${API_URL}bet/bettranscation`, body)
    // console.log(data)
    return data
  } catch (error) {
    console.log(error)
  }
}

const GetWinningPerAgent = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}report/getwinningbetsperteller`,
      body
    )
    // console.log(data)
    return data
  } catch (error) {
    console.log(error)
  }
}

export { GetBetsPerAgent, GetBets, GetWinningPerAgent }
